<script setup lang="ts">
/**
 * Bouton icône (carré ou rond, plusieurs variants).
 * Usage : navigation, suppression, actions ponctuelles.
 */
defineProps<{
  icon: string;
  ariaLabel: string;
  variant?: 'default' | 'danger' | 'ghost';
  disabled?: boolean;
  size?: 'sm' | 'md';
}>();
</script>

<template>
  <button
    type="button"
    :aria-label="ariaLabel"
    :disabled="disabled"
    :class="[
      'inline-flex items-center justify-center rounded-md transition-colors duration-160',
      size === 'sm' ? 'w-7 h-7 text-sm' : 'w-9 h-9 text-base',
      variant === 'danger'
        ? 'text-red-600 hover:bg-red-50'
        : variant === 'ghost'
          ? 'text-text-muted hover:text-text hover:bg-surface-muted/50'
          : 'text-text hover:bg-surface-muted',
      disabled && 'opacity-40 cursor-not-allowed hover:bg-transparent',
    ]"
  >
    <i :class="['ti', icon]" aria-hidden="true"></i>
  </button>
</template>
